module.exports = __webpack_public_path__ + "assets/img/25f61206412075b2a11fab23d7fea4e7.png";